import { useState } from 'react';
import { useRouteData } from '../RouteDataContext';
import { BalancePointCard, CartNoticeHelper, goToLink, ItemDetailCard, QuantityInput } from '../projectData';
import { KTSVG } from '../../../_metronic/helpers';
import AddToCartConfirm from './addTocartConfirm';
import { useNavigate } from 'react-router-dom';

/**
 * AddToCartDetail
 * Renders the detail page for adding an item to the cart.
 * Handles quantity selection, error display, and triggers add-to-cart confirmation.
 */
const AddToCartDetail = () => {
    const navigate = useNavigate()
    const { routeData, dashboard } = useRouteData()

    const transactionDetail = routeData?.location?.state;
    const [quantity, setQuantity] = useState(1)
    const [error, setError] = useState(null)
    const [loader, setLoader] = useState(false)
    /**
     * addToCartItem
     * Initiates the add-to-cart process and sets loading state.
     */
    const addToCartItem = () => {
        setLoader(true)
    }

    return (
        <div className="container bg-white vh-100">
            {Number(transactionDetail?.gift_type) === 1 ?
                <div className="row">
                    <div className="col-md-12 mt-10">
                        <ItemDetailCard data={{ image_url: transactionDetail?.image_url, sku_name: transactionDetail?.gift_name, redemed_point: transactionDetail?.gift_point }} />
                    </div>
                    {/* <div className="col-md-12">
                        <SelectedAddress address={transactionDetail?.userAddress} />
                    </div> */}
                </div>
                : <div className="row">
                    <div className="col-md-12 mt-10">
                        <ItemDetailCard data={{ image_url: transactionDetail?.image_url, sku_name: transactionDetail?.gift_name, redemed_point: transactionDetail?.gift_point }} />
                    </div>

                </div>
            }
            <div className="card p-3 mt-4" style={{ border: '1px solid #eaeaea' }}>
                <div className="fw-semibold fs-5 mb-2">Select QTY</div>
                <div className="d-flex align-items-start">
                    <QuantityInput quantity={quantity} error={error} setError={setError} changeQuantity={setQuantity} totalBalance={dashboard?.totalBalance} points={transactionDetail?.gift_point} />
                </div>
            </div>

            <div className='mt-4'>
                <BalancePointCard totalBalance={dashboard?.totalBalance} points={transactionDetail?.gift_point} qty={quantity} />
            </div>
            {error &&
                <div className="notice d-flex bg-light-danger rounded border-danger border border-dashed p-2 mt-5 mb-4">
                    <KTSVG path='/media/icons/duotune/general/gen044.svg' className='svg-icon-3x svg-icon-danger me-5' />
                    <div className="d-flex flex-stack flex-grow-1 flex-wrap flex-md-nowrap">
                        <div className=" mb-md-0 fw-semibold">
                            <div className="fs-7 text-gray-700 pe-7">
                                {error}
                            </div>
                        </div>
                    </div>
                </div>
            }
            {Number(transactionDetail?.gift_type) === 2 &&

                <div className="border rounded  mt-4" >
                    <div className="px-3 py-2 fw-semibold rounded-top fs-6 fw-semibold" style={{ backgroundColor: "#ECECEC" }}>Bank Account Details</div>
                    <div className="bg-white p-3 fs-7 rounded-bottom ">
                        <p class="mb-1 fs-7"><strong>Name -</strong>  {transactionDetail?.userBank.api_nameAtBank && `${transactionDetail?.userBank.api_nameAtBank}, `}</p>
                        <p class="mb-1 fs-7"><strong>Account No. -</strong>  {transactionDetail?.userBank.account_number && `${transactionDetail?.userBank.account_number}, `}</p>
                        <p class="mb-1 fs-7 text-uppercase"><strong>IFSC Code -</strong>  {transactionDetail?.userBank.ifsc_code && `${transactionDetail?.userBank.ifsc_code}, `}</p>
                        <p class="mb-0 fs-7"><strong>Bank Name -</strong>  {transactionDetail?.userBank.api_bankName && `${transactionDetail?.userBank.api_bankName}, `}</p>
                    </div>
                </div>

            }
            {(Number(transactionDetail?.gift_type) === 1 || Number(transactionDetail?.gift_type) === 6) && <div className="col-md-12">
                {/* <SelectedAddress address={transactionDetail?.userAddress} /> */}
                <div className="border rounded  mt-4" >
                    <div className="px-3 py-2 fw-semibold rounded-top fs-5 fw-semibold" style={{ backgroundColor: "#ECECEC" }}>Delivery Address</div>
                    <div className="bg-white p-3 rounded-bottom ">
                        {/* <div className="text-danger mb-1 fs-5 fw-semibold">Aman Dhiman</div> */}
                        <p className="mb-2 text-dark  fs-6">
                            {transactionDetail?.userAddress.address1 && `${transactionDetail?.userAddress.address1}, `}
                            {transactionDetail?.userAddress?.address2 && `${transactionDetail?.userAddress.address2}, `} <br />
                            {transactionDetail?.userAddress?.address3 && `${transactionDetail?.userAddress.address3}, `}
                            {transactionDetail?.userAddress?.landmark && `${transactionDetail?.userAddress.landmark}, `}
                            {transactionDetail?.userAddress?.city && `${transactionDetail?.userAddress.city}, `}<br />
                            {transactionDetail?.userAddress?.district && `${transactionDetail?.userAddress.district}, `}
                            {transactionDetail?.userAddress?.state && `${transactionDetail?.userAddress.state}, `}
                            {transactionDetail?.userAddress?.pincode && `${transactionDetail?.userAddress.pincode}`}
                        </p>
                        <div onClick={() => goToLink(navigate, `/customer/redem-detail/selectRedem-type/${transactionDetail.gifts_id}`, { itemValue: transactionDetail, dashboard: dashboard })} className="text-decoration-underline" style={{ color: "#0E3BEF" }}>Change Address</div>
                    </div>
                </div>

            </div>}
            <CartNoticeHelper gift_type={transactionDetail?.gift_type} />
            <div className='mt-3 text-center'>
                <button onClick={() => addToCartItem()} disabled={error} className='btn btn-danger btn-sm fs-3 w-100'>Add to Cart</button>
            </div>
            {
                loader &&
                <AddToCartConfirm closePopupLoding={setLoader} transactionDetail={transactionDetail} quantity={quantity} />
            }
        </div >
    )
}

export default AddToCartDetail